// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3uAFp","buttons":"SendReceipts_buttons__1wVEM","email":"SendReceipts_email__3YxM6","bookApptTitle":"SendReceipts_bookApptTitle__kupno"};